import { jsxs, jsx } from 'react/jsx-runtime';
import { Header } from '../Header/Header.esm.js';
import { Page } from './Page.esm.js';

function PageWithHeader(props) {
  const { themeId, children, ...restProps } = props;
  return /* @__PURE__ */ jsxs(Page, { themeId, children: [
    /* @__PURE__ */ jsx(Header, { ...restProps }),
    children
  ] });
}

export { PageWithHeader };
//# sourceMappingURL=PageWithHeader.esm.js.map
